module.exports = __webpack_public_path__ + "static/cortex-about-ferdie-min-3a3e25ed53b5bbd2e074b2ab044b00a9.png";